<template>
  <!-- 時間外管理登録画面 -->
  <div>
    <CCard>
      <CCardHeader>
        <h2>予定外時間外報告作成</h2>
      </CCardHeader>
      <CCardBody>
        <span class="asterisk">*</span><span>が付いている項目は必須入力項目です</span>
        <ValidationObserver ref="obs" v-slot="ObserverProps">
          <CRow>
            <div class="container">
              <table class="table table-borderless">

                <!-- 予定時間外勤務時間 -->
                <tr>
                  <th scope="row">予定時間外勤務時間<span class="asterisk">*</span></th>
                  <td>
                    <CRow>
                      <CCol sm="6" lg="3">
                        <ValidationProvider name="予定時間外勤務時間" rules="required|half_width_and_limit_decimal" v-slot="ProviderProps">
                          <CInput v-model="overtime">
                            <template #append-content>H</template>
                          </CInput>
                          <p class="error">
                            <font color="red">{{ ProviderProps.errors[0] }}</font>
                          </p>
                        </ValidationProvider>
                      </CCol>
                    </CRow>
                  </td>
                </tr>

                <!-- 発生理由 -->
                <tr>
                  <th scope="row">発生理由<span class="asterisk">*</span></th>
                  <td>
                    <CRow>
                      <CCol sm="12" lg="6">
                        <ValidationProvider name="発生理由" rules="required" v-slot="ProviderProps">
                          <CTextarea
                            v-model="reason"
                            rows="2"
                            style="resize: vertical;"
                          />
                          <p class="error">
                            <font color="red">{{ ProviderProps.errors[0] }}</font>
                          </p>
                        </ValidationProvider>
                      </CCol>
                    </CRow>
                  </td>
                </tr>
              </table>
              <CRow class="mt-3 align-items-center">
                <CCol class="text-start">
                  <button class="btn btn-secondary" @click="valueCheck">戻る</button>
                </CCol>
                <CCol class="text-center">
                  <save-button
                    :label="'報告'"
                    :loading="loading"
                    :disabled="ObserverProps.invalid"
                    @click="update"
                    class="btn btn-primary"
                  />
                </CCol>
                <CCol></CCol>
              </CRow>
              <label class="mt-2">※ 別途申請処理無く上長が内容を確認します。（申請機能未実装）</label>
            </div>
          </CRow>
        </ValidationObserver>
      </CCardBody>
    </CCard>
  </div>
</template>


<script>
import ConstList from "./../../ConstList";
import axios from "axios";
import SaveButton from '../../common/SaveButton';
export default {
  components: { SaveButton },
  name: "UpdateInput",
  data() {
    return {
      overtime: 0,
      reason: "",
      // 二重サブミット対処フラグ
      submit_flg: false,
      loading: false,
    };
  },
  computed: {
    DATE_MIN() {
      return ConstList.DATE_MIN;
    },
    DATE_MAX() {
      return ConstList.DATE_MAX;
    },
  },

  // 詳細画面から各種情報を取得
  mounted: function () {
    this.id = this.$route.params.id;
    const id = parseInt(this.id);
    axios
      .get(process.env.VUE_APP_API_ORIGIN + "/overtime/" + id)
      .then((response) => {
        if (response.data.length === 0) {
          this.errors.push(ConstList.EMPTY);
        }
        const overtimeData = response.data;
        this.overtime = overtimeData.overtime;
        this.updated_at = overtimeData.updated_at;
        this.reason = overtimeData.reason;
      })
      .catch((error) => {
        axios
        .get(
          `${process.env.VUE_APP_API_ORIGIN}/error/frontError/${error}`
        )
        .then(() => {
          alert(ConstList.SYSTEM_ERROR);
        })
        .catch(() => {
          alert(ConstList.SYSTEM_COMMUNICATION_ERROR);
        });
      });
  },

  methods: {
    // 修正情報を送信
    update: function () {
      // 二重サブミット対策
      if (this.submit_flg) return;
      //フラグがfalseならば、フラグをtrueにしたうえでsubmit
      this.submit_flg = true;
      if (confirm) {
        this.loading = true;
        const params = new URLSearchParams();
        params.append("overtime", this.overtime);
        params.append("reason", this.reason);
        this.id = this.$route.params.id;
        const id = parseInt(this.id);
        axios
          .post(
            process.env.VUE_APP_API_ORIGIN + "/overtimeUpdate/" + id,
            params
          )
          .then((response) => {
            this.submit_flg = false;
            if (response.data === ConstList.SUCCESS) {
              alert(ConstList.REGISTER_MESSAGE);
              this.$router.push({ name: "予定外時間外報告" });
            } else {
              this.message[0] = response.data;
              location.hash = ConstList.UPDATE_TOP;
            }
          })
          .catch((error) => {
            this.submit_flg = false;
            axios
            .get(
              `${process.env.VUE_APP_API_ORIGIN}/error/frontError/${error}`
            )
            .then(() => {
              alert(ConstList.SYSTEM_ERROR);
            })
            .catch(() => {
              alert(ConstList.SYSTEM_COMMUNICATION_ERROR);
            });
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
    valueCheck: function () {
      if ((this.overtime != 0) || 
        (this.reason != '')) {
        if (confirm(ConstList.TRANSITION)) {
          this.$router.push({
            name: ConstList.ROUTE_OVERTIMES_INFO,
          })
        }
      } else {
        this.$router.push({
          name: ConstList.ROUTE_OVERTIMES_INFO,
        })
      }
    },
  },
};
</script>

<style scoped>
button:disabled {
  cursor: not-allowed;
}

.container {
  margin-left: 0%;
}
</style>
